import React from 'react';
import { BulkUploadDialogPaper } from '../styles';

/**
 * The one frame bulk upload runs in, wherever it is entered from.
 *
 * Step 1 used to render as a fixed panel over the docs screen while steps 2-5
 * opened in this dialog on /drafts/:assignmentId — the same wizard wearing two
 * different frames, with a landing page wedged between them. Both entry points
 * mount this instead, so creating the draft at step 1 changes the route
 * underneath the popup and nothing else.
 *
 * `open` is the only gate: MUI renders nothing while it is false, so the flow
 * still unmounts — and its queries still stop — between visits, but the modal
 * itself is reused and gets its close transition.
 */
export const BulkUploadDialog = ({ open, onClose, children }) => (
  <BulkUploadDialogPaper
    open={open}
    onClose={onClose}
    maxWidth={false}
    fullWidth
    data-testid="bulk-upload-dialog"
  >
    {children}
  </BulkUploadDialogPaper>
);
